export default {
  title: 'Material Library',
  tabImage: 'Image',
  tabVideo: 'Video',
  upload: 'Upload Image',
  uploadVideo: 'Upload Video',
  batchGroup: 'Move Group',
  batchDelete: 'Batch Delete',
  selected: 'Selected',
  item: 'item(s)',
  cancelSelect: 'Cancel Selection',
  searchNamePlaceholder: 'Search by name',
  uploadNow: 'Upload Now',
  editTitle: 'Edit Material',
  materialName: 'Material Name',
  materialNamePlaceholder: 'Please enter material name',
  moveGroupTitle: 'Move Group',
  targetGroup: 'Target Group',
  selectGroupPlaceholder: 'Please select a group',
  confirmDeleteSingle: 'Are you sure to delete this item?',
  confirmDelete: 'Are you sure to delete selected items?',
  emptyImage: 'No images yet',
  emptyVideo: 'No videos yet',
};
